import { Add } from '@mui/icons-material';
import type { ISmallSkill } from '@sharedInterfaces/IWhoIAm';
import Button from '@src/App/Components/Buttons/Button/Button';
import Item from '@src/App/Components/Items/EntityItems/Item/Item';
import type { INewSkill } from '@src/App/Components/Lists/EditSkillList/EditSkillList';
import React, { useEffect, useRef } from 'react';

import SkillSearchBox from '../../searchBoxes/SkillSearchBox/SkillSearchBox';
import SegmentRateBar from '../SegmentRateBar/SegmentRateBar';

interface NewSkillRowProps {
    maxLevel: number;
    filteredAllSkills: ISmallSkill[];
    newSkill: INewSkill;
    allowNewSkills?: true;
    minLevel?: number;
    onNewSkillChange: (newSkill: INewSkill) => void;
    onAddClick: () => void;
}
const NewSkillRow: React.FC<NewSkillRowProps> = ({
    minLevel,
    maxLevel,
    filteredAllSkills,
    newSkill,
    allowNewSkills,
    onNewSkillChange,
    onAddClick,
}) => {
    const elementRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setTimeout(() => {
            if (elementRef.current && newSkill.title !== '') {
                const element: HTMLInputElement | null | HTMLSelectElement =
                    elementRef.current.querySelector('.rateBarInputElement');
                element && element.focus();
            }
        }, 50);
    }, [newSkill.title, elementRef]);
    return (
        <div
            className="newSkillRow"
            ref={elementRef}
            style={{ '--percent': `${(newSkill.level / maxLevel) * 100}`, order: 999 } as React.CSSProperties}
        >
            <Item
                rightContent={
                    <Button
                        size="verysmall"
                        onClick={() => {
                            onAddClick();
                            setTimeout(() => {
                                if (elementRef.current) {
                                    const element: HTMLInputElement | null | HTMLSelectElement =
                                        elementRef.current.querySelector('.entitySearchBoxInput input');
                                    element && element.focus();
                                }
                            }, 50);
                        }}
                        icon={<Add />}
                        disabled={newSkill.title === '' || newSkill.level === 0}
                        text="Add"
                    />
                }
            >
                <SkillSearchBox
                    filteredAllSkills={filteredAllSkills}
                    newSkill={newSkill}
                    size="small"
                    allowNew={allowNewSkills}
                    setNewSkill={(newSkill) => {
                        onNewSkillChange({ ...newSkill, level: 0 });
                    }}
                />
                {newSkill.title !== '' && (
                    <SegmentRateBar
                        level={newSkill.level}
                        maxLevel={maxLevel}
                        title={newSkill.title}
                        onChange={(newLevel) => onNewSkillChange({ ...newSkill, level: newLevel })}
                    />
                )}
            </Item>
        </div>
    );
};
export default NewSkillRow;
